import { keyframes } from 'styled-components';
import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { fontBold, fontNormal } from 'style/styled-components/cssGlobalVariables';
import { Breakpoints, MQ, MQ_TOUCH } from 'style/styled-components/cssMediaQueries';

export const sliderDesktopMarginLeft = 24;

const pulse = keyframes`
    0%, 40% {
        background-color: #EE0011;
    }
    50%, 90% {
        background-color: #890009ff;
    }
    100% {
        background-color: #EE0011;
    }
`;

export const LiveIndicator = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 4px;

    &::after {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #ee0011;
        animation: ${pulse} 3s linear infinite;
    }
`;

export const ShowAllButton = styled.div`
    float: left;
    cursor: pointer;
    position: relative;
    font-family: ${fontNormal};

    ${MQ(Breakpoints.m)} {
        padding-top: 2px;
    }

    a {
        display: block;
        position: relative;
    }
`;

export const SliderWrapper = styled.div<{ isMobile: boolean }>`
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 0px;
    margin-top: 12px;
    position: relative;
    text-align: left;

    ${MQ_TOUCH} {
        margin-top: 0;
    }

    ${MQ(Breakpoints.m)} {
        margin-left: ${sliderDesktopMarginLeft}px;
    }

    &:last-child {
        margin-bottom: 0;
    }

    .slide-container {
        white-space: nowrap;
    }
`;

export const SliderTitle = styled.div`
    display: flex;
    align-items: center;
    font-size: 20px;
    line-height: 24px;
    max-width: 100%;
    overflow: hidden;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
    position: relative;
    text-align: left;
    white-space: nowrap;
    width: 100%;
    font-family: ${fontBold};
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    transition: opacity 0.5s ease-in-out;

    a {
        display: flex;
        align-items: center;
    }

    ${MQ(Breakpoints.s)} {
        padding-left: 40px;
        padding-right: 40px;
    }

    ${MQ(Breakpoints.m)} {
        padding-left: 48px;
        padding-right: 48px;
    }
`;

export const SliderTitleText = styled.h2<{ maxWidth?: string }>`
    float: left;
    font-size: 20px;
    max-width: ${(props) => props.maxWidth};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const TilesContainer = styled.div`
    position: relative;
`;
